export default function SvgPlus(props) {
    return (
        <svg {...props} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.52441 0V19" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
            <path d="M19 9.52466H0" stroke="white" strokeWidth="2" strokeMiterlimit="10"/>
        </svg>

    )
}